import React from "react";

function WomenTimeline() {
  return (
    <div>
      <h2 className="text-h-orange pt-5">
        “The threat of imprisonment has long been used to quell dissent in the
        subcontinent, and women have been no exception to politically motivated
        arrests across colonial and postcolonial periods.”
      </h2>
      <p>- Author Radha Shah</p>

      <div className="voice-sect">
        <div className="voice-sect-style"></div>
        <div className="voice-sect-style">
          <p>
            Women’s prisons were imagined as spaces that would prevent and
            provide correctives for what were seen as particular forms of female
            criminality and signs of their fall from womanhood. But reform
            initiatives always circled back to the need for segregation from
            men.
          </p>
          <p>
            Ideological underpinnings about women needing protection due to a
            child-like impressionability to bad influence allowed jail
            administrators to view them as a unique imperial opportunity for
            gendered civilisational reform.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WomenTimeline;
